import { observable, computed, action } from 'mobx';
import STATUS from './states';

export default class TaskState {
	/** current task status (see ./states) */
	@observable status = STATUS.pending;

	/** set to the error when rejected */
	@observable error = null;

	/** set to the result when resolved */
	@observable result = null;

	@computed
	get loading() {
		return this.status === STATUS.loading;
	}

	@computed
	get pending() {
		return this.status === STATUS.pending;
	}

	@computed
	get rejected() {
		return this.status === STATUS.rejected;
	}

	@computed
	get resolved() {
		return this.status === STATUS.resolved;
	}

	@computed
	get done() {
		return this.status === STATUS.rejected || this.status === STATUS.resolved;
	}

	@action
	setInLoading() {
		this.status = STATUS.loading;
		this.error = null;
		this.result = null;
	}

	@action
	setInPending() {
		this.status = STATUS.pending;
		this.error = null;
		this.result = null;
	}

	@action
	setInResolved(result) {
		this.status = STATUS.resolved;
		this.error = null;
		this.result = result;
	}

	@action
	setInRejected(error) {
		this.status = STATUS.rejected;
		this.error = error;
		this.result = null;
	}
}



// WEBPACK FOOTER //
// ./src/state/helpers/task/TaskState.js